import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { AccountListFacadeService } from '@rogers/self-serve-common/account';
import { UserAccount } from '@rogers/self-serve-common';
import { LINK_ACCOUNT_URL } from '@rci/self-serve-fido/app.constant';
import { LoginStateFacade } from '@rci/self-serve-fido/core/fido-login-state/login-state.facade';

@Injectable({
  providedIn: 'root',
})
export class AreAccountsLinkedGuard implements CanActivate {
  private readonly accountListFacadeService = inject(AccountListFacadeService);
  private readonly loginStateFacade = inject(LoginStateFacade);
  private readonly routingService = inject(RoutingService);

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.loginStateFacade.isLoggedIn$.pipe(
      filter(isLoggedIn => isLoggedIn),
      switchMap(_ => this.accountListFacadeService.accountList$),
      filter(accounts => !!accounts),
      map((accounts: UserAccount[]) => {
        if (accounts.length === 0) {
          this.routingService.navigate(LINK_ACCOUNT_URL);
        }
        return accounts.length > 0;
      }),
    );
  }
}
